import {configureStore, getDefaultMiddleware, createStore, applyMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import reducer from './combineReducer';
import api from './middleware/api';
import checkAccess from './middleware/checkAccessToken';

const persistConfig = {
  key: 'root',
  storage,
}

const middleware = [...getDefaultMiddleware(), api]
// const persistedReducer = persistReducer(persistConfig, reducer)

export default function () {
  let store = createStore(reducer, applyMiddleware(...middleware))
  // let store = configureStore({ 
  //   persistedReducer,
  //   middleware: [...getDefaultMiddleware(), api]
  // })
  let persistor = persistStore(store)
  return { store, persistor }
}; 